import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { formatDate } from '@angular/common';
import { mounthsHU } from './Localization/monthsHU';
import { mounthsEN } from './Localization/monthsEN';
import { weekdayEN } from './Localization/weekdaysEN';
import { weekdayHU } from './Localization/weekdaysHU';
import { yearsLabel } from './Localization/years';
import { IEventData } from './Interface/IEventData';
import { dateFromYYYYMMDD } from '../../../bo9-shared/helpers/time.helper';


@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarComponent implements OnInit, AfterViewInit, OnChanges {


  isSmall = false;

  today;
  currentMonth: number;
  currentYear: number;
  firstDay: number;
  daysInMonth: number;
  daysInLastMonth: number;
  actDay: number;
  lastMonth: number;
  actMonth: number;
  months: any;
  weekdays: any;
  years: number[]= [];
  actFullDate: string;
  actDate: string;
  calendarDays: any[] = [];
  arrCalendar: any = [];
  eventsData: any;
  actYear: number;
  showChangeDate = false;

  @Input() dataSource: IEventData[] | null;
  @Input() language: string;
  @Output() dayEvents = new EventEmitter();
  @Output() newEvent = new EventEmitter();
  @Output() newMonth: EventEmitter<{month: number, year:number}> = new EventEmitter<{month: number, year:number}>();

  constructor() {
    this.today = new Date();
    this.currentMonth = this.today.getMonth();
    this.currentYear = this.today.getFullYear();
    this.years = yearsLabel;

  }

  ngOnInit() {
    this.actFullDate = formatDate(new Date(), 'yyyy. MMMM. dd', 'en');
    this.actDate = formatDate(new Date(), 'yyyy. MMMM', 'en');
    this.actDay = this.today.getDate();
    this.actMonth = this.today.getMonth();
    this.actYear = this.today.getFullYear();
    this.eventsData = this.dataSource;
  }

  ngAfterViewInit(): void {
    const height = document.getElementById('cont')!.offsetHeight;
    const width = document.getElementById('cont')!.offsetWidth;

    // TODO: if small only show badges not all the events
    if (height <= 600 || width <= 700) {
       console.log('small');
      this.isSmall = true;
    } else {
      this.isSmall = false;
    }

  }



  ngOnChanges() {
    this.eventsData = this.dataSource;
    console.log("EVENTS SIZE "+this.eventsData.length);
    this.changeLanguage();
    this.createCalendar();
  }

  createCalendar() {
    this.arrCalendar = [];
    this.calendarDays=[];
    this.firstDay = new Date(this.currentYear, this.currentMonth).getDay();
    this.daysInMonth = this.getDaysInMonth(this.currentMonth, this.currentYear);
    this.daysInLastMonth = this.getDaysInMonth(
      this.currentMonth - 1,
      this.currentYear
    );
    const lmd = this.daysInLastMonth - (this.firstDay - 1);

    // Last month days
    for (let index = lmd; index <= this.daysInLastMonth; index++) {
      
      this.calendarDays.push({
        day: index,
        month: this.currentMonth - 1,
        year: this.currentYear,
        events: this.getDaysEvents(index, this.currentMonth -1, this.currentYear)
      });
    }

    // Actual month
    for (let index = 1; index <= this.daysInMonth; index++) {
      this.calendarDays.push({
        day: index,
        month: this.currentMonth,
        year: this.currentYear,
        events: this.getDaysEvents(index, this.currentMonth, this.currentYear)
      });
    }
    
    for (let index = 1; index <= this.daysInMonth; index++) {
      this.calendarDays.push({
        day: index,
        month: this.currentMonth + 1,
        year: this.currentYear,
        events: []
      });
    }

    for (let i = 0; i < 6; i++) {
      const arrWeek: any[] = this.calendarDays.splice(0, 7);
      this.arrCalendar.push(arrWeek);
    }

  }

  getDaysEvents(day: number, month: number, year: number) : IEventData[] {

    if (this.eventsData && this.eventsData.length > 0) {
        const filterEvents = this.eventsData.filter(function(event:any){
          const daystart = new Date(
            year,
            month,
            day-1,
            0,0,0
          ); 
          const dayend = new Date(
            year,
            month,
            day-1,
            23,59,59
          );
          /*
          if ( (event.startTimeUTC.getTime() >=  daystart.getTime() && event.startTimeUTC.getTime() <= dayend.getTime()) || 
                (event.endDate.getTime() >=  daystart.getTime() && event.endDate.getTime() <= dayend.getTime())  ||
                (event.startTimeUTC.getTime() <  daystart.getTime() && event.endDate.getTime() > dayend.getTime()) 
                */
          const eventDate = dateFromYYYYMMDD(event.startDate);
          if ( (eventDate.getTime() >=  daystart.getTime() && eventDate.getTime() <= dayend.getTime()) 
                ) {
                  return true;
                } else {
                  return false;
                }
        });

        if (filterEvents.length > 0) {
          for (const e of filterEvents) {
            e.startTime = e.startTimeUTC.getHours()+":"+e.startTimeUTC.getMinutes().toString().padEnd(2,"0");
          }
          return  filterEvents;
        }

    }
    return [];
  }

  getDaysInMonth(iMonth: any, iYear:any) {
    return 32 - new Date(iYear, iMonth, 32).getDate();
  }

  previousMonthButtonClick() {
    if (this.currentMonth === 0) {
      this.currentYear -= 1;
      this.currentMonth = 11;
    } else {
      this.currentMonth -= 1;
    }

    this.actDate = this.creatActMonthYear();
    this.newMonth.emit({month:this.currentMonth, year:this.currentYear})
    this.createCalendar();
  }

  nextMonthButtonClick() {
    if (this.currentMonth === 11) {
      this.currentYear += 1;
      this.currentMonth = 0;
    } else {
      this.currentMonth += 1;
    }

    this.actDate = this.creatActMonthYear();

   this.newMonth.emit({month:this.currentMonth, year:this.currentYear})
   //console.log("nextMonth"+JSON.stringify(this.actDate));
    this.createCalendar();
  }

  // Dialog test
  // TODO: return the selected value
  openDialog(event:any) {
    this.dayEvents.next(event);
  }

  changeLanguage() {
    if (!this.language) {
      this.language = 'hu';
      this.months = mounthsHU;
      this.weekdays = weekdayHU;
    }
    if (this.language === 'en') {
      this.months = mounthsEN;
      this.weekdays = weekdayEN;
    } else {
      this.months = mounthsHU;
      this.weekdays = weekdayHU;
    }
  }

  onYearChange(event:any) {
    this.currentYear = Number(event.target.value);

    this.actDate = this.creatActMonthYear();

    this.createCalendar();
  }

  onMonthChange(event:any) {
    this.currentMonth = Number(event.target.value);

    this.actDate = this.creatActMonthYear();

    this.createCalendar();
  }

  creatActMonthYear() {
    const actDate = formatDate(
      new Date(this.currentYear, this.currentMonth),
      'yyyy. MMMM',
      'en'
    );

    return actDate;
  }

  addEventClicked() {

    const testMessage = `${this.currentYear}-${this.currentMonth}-${this.actDay}`;
    this.newEvent.next(testMessage);
  }

}
